export default {
    init() {
        // JavaScript to be fired on the blog page
    },
    finalize() {
        var indexPlaceHolder = 0;
        var valuesPlaceHolder = $(".fake-placeholder").data("values").split(',');

        $('.apply-filter').hide();
        $(".archive-blogrs").find("[name='category_id']").val($(".select-categories option:selected").val());
        $(".select-categories").on("change", function () {
            $(this).parent().find('.apply-filter').show();
        });
        $(".apply-filter").on("click", function () {
            var search_value = $(".search-input").val();
            var value = $(".select-categories option:selected").val();
            $(".select-categories").parent().find("[name='category_id']").val(value);
            $(this).hide();
            $(".search-input").val(search_value);
            $(".search-row").submit();
        });
        $(".search-icon").on("click", function () {
            checkSubmit();
        });
        $(".search-input").on("keyup", function (e) {
            if (e.which === 13) {
                checkSubmit();
            }
            if ($(".search-input").val() === "") {
                nextPlaceHolder(indexPlaceHolder, valuesPlaceHolder);
            } else {
                $(".fake-placeholder").hide();
            }
        });
        $(".alert-not-found").on('close.bs.alert', function () {
            window.location.href = $(this).data('url');
        });
        setInterval(function () {
            nextPlaceHolder(indexPlaceHolder, valuesPlaceHolder);
            indexPlaceHolder++;
            if (indexPlaceHolder === valuesPlaceHolder.length) {
                indexPlaceHolder = 0;//restart loop
            }
        }, 3000);

        function checkSubmit() {
            if ($(".search-input").val() === "") {
                $(".search-input").val(" ");
            }
            $(".search-row").submit();
        }

        function nextPlaceHolder(index, values) {
            if ($(".search-input").val() == "") {
                $(".fake-placeholder").hide().html($(".fake-placeholder").attr('data-pre-values') + " " + "<span class=\"hot\">" + values[index] + "</span>" + "?").fadeIn("slow").css("display", "inline");
            }
        }
    },
};



// WEBPACK FOOTER //
// ./scripts/routes/blog.js